import { render, staticRenderFns } from "./InputForms.vue?vue&type=template&id=9d17dc66&scoped=true&"
import script from "./InputForms.vue?vue&type=script&lang=ts&"
export * from "./InputForms.vue?vue&type=script&lang=ts&"
import style0 from "./InputForms.vue?vue&type=style&index=0&id=9d17dc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d17dc66",
  null
  
)

export default component.exports